import React, { useContext, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { PolicyManagementContextStore } from '../../../context/PolicyManagementContext'
import { ActiveInsuranceModel } from '../../../models/insurance-models/ActiveInsuranceModel'
import { BrowserView, isMobile, MobileView } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import { ReactComponent as Pilot } from '../../../assets/pilot_blue.svg'
import { ReactComponent as Airplane } from '../../../assets/airplane.svg'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { LiabilitySection } from './PolicyDetailSections/LiabilitySection'
import { Container, Grid, Divider } from '@material-ui/core'
import './PolicyDetails.scss'
import { SkyPaper } from '../../Core/Frames/SkyPaper'
import { PolicyHullSection } from './PolicyDetailSections/PolicyHullSection'
import { AutoRenewSection } from './PolicyDetailSections/AutoRenewSection'
// import { DiscountRenewal } from '../../Core/DiscountRenewal'
import { PolicyAdditionalInsuredSection } from './PolicyDetailSections/PolicyAdditionalInsuredSection'
import { InsuranceTypes } from '../../../models/insurance-models/InsuranceBillingPeriodModel'
import { YourPolicyDetailsSection } from './PolicyDetailSections/YourPolicyDetailsSection'
import { PolicyUpdates } from './PolicyUpdates/PolicyUpdates'
import { BackButtonTitle } from '../../Core/BackButtonTitle'
import { PolicyActions } from './PolicyActions'
import { isUK } from '../../../services/utils'
import { PolicyOperatorsSection } from './PolicyDetailSections/PolicyOperatorsSection'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { PolicyRenewalPricingSection } from './PolicyDetailSections/PolicyRenewalPricingSection'
import { PolicyRenewalContextStore } from '../../../context/PolicyRenewalContext'
import { SUBSCRIPTION_STATE } from '../../../models/insurance-models/PolicySubscriptionState'
import { IsCommercialPopup } from '../../PopUps/IsCommercialPopup'
import { PolicyAdditionalCoveragesSection } from './PolicyDetailSections/PolicyAdditionalCoveragesSection'
import { SessionContextStore } from '../../../context/SessionContext'
import dayjs from 'dayjs'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import {ModificationContextStore} from '../../../context/ModificationContext'

var classNames = require('classnames')

export const PolicyDetails = () => {
    const myPoliciesContext = useContext(PolicyManagementContextStore)
    const policyRenewalContext = useContext(PolicyRenewalContextStore)
    const offersContext = useContext(BuyingInsuranceContextStore)
    const sessionContext = useContext(SessionContextStore)
    const modificationContext = React.useContext(ModificationContextStore)
    const history = useHistory()
    let { insuranceId } = useParams()
    const [isRenewal,setIsRenewal] = React.useState(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.RENEWAL)
    let insurance: ActiveInsuranceModel = myPoliciesContext.all_policies.find(
        (pol: ActiveInsuranceModel) => pol.insuranceId == insuranceId
    )
    let nextInsuranceEndDateAnnual = isRenewal? new Date(insurance.subscription.nextBillingDate.getFullYear()+1,insurance.subscription.nextBillingDate.getMonth() + 1,insurance.subscription.nextBillingDate.getDate()): new Date()
    let nextInsuranceEndDateMonthly = isRenewal? new Date(insurance.subscription.nextBillingDate.getFullYear(),insurance.subscription.nextBillingDate.getMonth() + 1,insurance.subscription.nextBillingDate.getDate()): new Date()

    React.useEffect(() => {
        offersContext.updateCartWithInsurance(insurance)
    }, [insurance])

    React.useEffect(() => {
        setIsRenewal(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.RENEWAL)
    }, [policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.RENEWAL])

    return (
        <>
            <Container
                className={classNames(
                    { 'policy-details-container': !isMobile },
                    'margin-top-medium'
                )}
            >
                {/* <MobileView>
                    
                    <BackButtonTitle onBackPressed={() => history.replace('/policy-management')} title={`Your ${insurance.insuranceType} Policy`} />
                    <br/>
                    <YourPolicyDetailsSection />
                    <br/>
                    <PolicyUpdates />
                    <br/>
                    <LiabilitySection insurance={insurance} />
                    
                    <Divider />

                    {insurance.insuranceType != InsuranceTypes.HOURLY && <PolicyHullSection insurance={insurance} />}

                     <Divider />

                     <PolicyAdditionalCoveragesSection insurance={insurance} />

                     <Divider />
                    
                    <PolicyAdditionalInsuredSection insurance={insurance} />
                    
                    <Divider />

                    {insurance.insuranceType != InsuranceTypes.HOURLY && (insurance.renewable) && <React.Fragment>
                        <AutoRenewSection insurance={insurance} />
                        <Divider />
                    </React.Fragment>  }

                    {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT && 
                        <div className="margin-top-basic">
                            <PolicyActions insurance={insurance} />
                    </div>}

                    {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.RENEWAL && 
                        <PolicyRenewalPricingSection insurance={insurance} /> }
                    <br />
                </MobileView> */}
                <br />
                <YourPolicyDetailsSection />
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <SkyPaper>
                            <FlexView>
                                <Pilot className="large-icon" />
                                <div className="margin-left-12">
                                    {console.log(insurance)}
                                    <div className="text-body bold black">
                                        Policy Holder
                                    </div>
                                    <div className="text-tiny black">
                                        {isRenewal? insurance.subscription.namedInsured.firstName : insurance.namedInsured.firstName}{' '}
                                        {isRenewal? insurance.subscription.namedInsured.lastName : insurance.namedInsured.lastName}
                                    </div>
                                </div>
                            </FlexView>
                        </SkyPaper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <SkyPaper>
                            <FlexView>
                                <Airplane className="large-icon" />
                                <div className="margin-left-12">
                                    <div className="text-body bold black">
                                        Aircraft Type
                                    </div>
                                    <div className="text-tiny black">
                                        {insurance.insuredVehicles[0]
                                            .multiEngineLand && (
                                            <div>Multi Engine Land</div>
                                        )}
                                        {insurance.insuredVehicles[0]
                                            .singleEngineLand && (
                                            <div>Single Engine Land</div>
                                        )}
                                        {insurance.insuredVehicles[0]
                                            .singleEngineSeaplane && (
                                            <div>Single Engine Seaplane</div>
                                        )}
                                    </div>
                                </div>
                            </FlexView>
                        </SkyPaper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <SkyPaper>
                            <FlexView>
                                <DateRangeIcon className="blue large-icon" />
                                {!isRenewal?
                                    (<div className="margin-left-12">
                                    <div className="text-body bold black">
                                        Policy Period
                                    </div>
                                    <div className="text-tiny black">
                                        {dayjs(isRenewal? (insurance.subscription.nextBillingDate) : insurance.insuranceStart).format(
                                            FirebaseService.getValue(
                                                FirebaseConfigKey.LONG_DATE_FORMAT
                                            )
                                        )}{' '}
                                        -{' '}
                                        {dayjs(insurance.insuranceEnd).format(
                                            FirebaseService.getValue(
                                                FirebaseConfigKey.LONG_DATE_FORMAT
                                            ))}
                                    </div>
                                    </div>)
                                    :(<div className="margin-left-12">
                                    <div className="text-body bold black">
                                        Policy renews at
                                    </div>
                                    <div className="text-tiny black">
                                        {dayjs(isRenewal? (insurance.subscription.nextBillingDate) : insurance.insuranceStart).format(
                                            FirebaseService.getValue(
                                                FirebaseConfigKey.LONG_DATE_FORMAT
                                            )
                                        )}{' '}
                                    </div>
                                    </div>)
                                }

                                {/* <div className="margin-left-12">
                                    <div className="text-body bold black">
                                        {isRenewal ? 'Policy renews at' : 'Policy Period'}
                                    </div>
                                    <div className="text-tiny black">
                                        {dayjs(isRenewal? (insurance.subscription.nextBillingDate) : insurance.insuranceStart).format(
                                            FirebaseService.getValue(
                                                FirebaseConfigKey.LONG_DATE_FORMAT
                                            )
                                        )}{' '}
                                        -{' '}
                                        {!isRenewal &&dayjs(insurance.insuranceEnd).format(
                                            FirebaseService.getValue(
                                                FirebaseConfigKey.LONG_DATE_FORMAT
                                            ))}
                                    </div>
                                </div> */}
                            </FlexView>
                        </SkyPaper>
                    </Grid>
                    {/* <Grid item xs={12}>
                            <SkyPaper> */}
                    <LiabilitySection insurance={insurance} isRenewal={isRenewal}/>
                    {/* </SkyPaper>
                        </Grid> */}
                    <Grid item xs={12}>
                        <SkyPaper>
                            <FlexView className="space-between">
                                <div className="text-body bold black">
                                    Medical Payments
                                </div>
                                {/* <div>{Object.keys(insurance.policyCoverages).map(x => x == "medicalPayments" ?  (<div> {insurance.policyCoverages[x].liability} Liability limit</div>) : <></>)} </div> */}
                            </FlexView>
                            <FlexView
                                column={isMobile}
                                className={classNames(
                                    { 'space-between': !isMobile },
                                    'margin-top-small'
                                )}
                            >
                                <div className="black text-small">
                                    {' '}
                                    {
                                        insurance.policyCoverages[
                                            'medicalPayments'
                                        ].liability
                                    }{' '}
                                    Liability limit
                                </div>
                                <div className="gray margin-top-small text-tiny">
                                    Premium:{' '}
                                    {FirebaseService.getValue(
                                        FirebaseConfigKey.CURRENCY_SYMBOL
                                    )}
                                    {!isRenewal &&
                                        insurance.policyCoverages[
                                            'medicalPayments'
                                        ].price
                                    }
                                    {isRenewal &&
                                        modificationContext.subscription.offer[
                                            'medicalPayments'
                                        ].price
                                    }
                                </div>
                            </FlexView>
                        </SkyPaper>
                    </Grid>
                    <Grid item xs>
                        {insurance.insuranceType != InsuranceTypes.HOURLY &&
                            insurance.renewable && (
                                <SkyPaper>
                                    <AutoRenewSection insurance={insurance} />
                                </SkyPaper>
                            )}

                        <div
                            className={classNames({
                                'margin-top-basic':
                                    insurance.insuranceType !=
                                        InsuranceTypes.HOURLY &&
                                    (insurance.renewable ||
                                        insurance.autoRenew),
                            })}
                        >
                            {insurance.additionalInsuredName && (
                                <SkyPaper>
                                    <PolicyAdditionalInsuredSection
                                        insurance={insurance}
                                    />
                                </SkyPaper>
                            )}
                            {/* 
                                {FirebaseService.getBoolean(FirebaseConfigKey.OPERATOR_EDITING_AVAILABLE) && <SkyPaper>
                                    <PolicyOperatorsSection insurance={insurance} />
                                </SkyPaper>} */}
                        </div>

                        {/* {insurance.insuranceType != InsuranceTypes.HOURLY && (insurance.renewable) && !isUK() 
                                && <div className="margin-top-basic">
                                <DiscountRenewal />
                            </div>} */}

                        {policyRenewalContext.insuranceSubscriptionState ==
                            SUBSCRIPTION_STATE.CURRENT && (
                            <div className="margin-top-basic">
                                <PolicyActions insurance={insurance} />
                            </div>
                        )}
                    </Grid>
                </Grid>
            </Container>
            <IsCommercialPopup />
        </>
    )
}
